<template>
  <layout>
    <template v-slot:title>Edit Section</template>
    <section-form
      v-if="section"
      :section="section"
      @save="savedOrCanceled"
      @cancel="savedOrCanceled"
    ></section-form>
  </layout>
</template>
<script>
import documentModelMixin from "@/mixins/documentModel";
import SectionForm from "@/components/sections/SectionForm.vue";

export default {
  components: { SectionForm },
  mixins: [documentModelMixin],
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data: function() {
    return {
      section: null,
    };
  },
  methods: {
    savedOrCanceled: function() {
      this.$router.push("/sections");
    },
  },
  mounted: function() {
    this.section = this.documentModel.findContentControl(parseInt(this.id, 10));
  },
};
</script>
